import { render, staticRenderFns } from "./VaultSettingsOverwrite.vue?vue&type=template&id=5c739fe5"
import script from "./VaultSettingsOverwrite.vue?vue&type=script&lang=js"
export * from "./VaultSettingsOverwrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports